import { FC, useEffect, useState } from 'react';
import { Image, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { IS_WEB, SCREEN_WITDH } from '../../../constants/platform';
import EnhancedImageViewing from 'react-native-image-viewing';
import RenderHTML from 'react-native-render-html';

interface SendMessageProps {
  content?: string;
  time: string;
  type?: 'text' | 'image';
  media?: {
    id: number;
    name: string;
    original_url: string;
    image_sizes: {
      height: number;
      width: number;
    };
  }[];
}

const SendMessage: FC<SendMessageProps> = ({
  content,
  time,
  type = 'text',
  media = [],
}) => {
  const [imageW, setImageW] = useState<number>(1);
  const [imageH, setImageH] = useState<number>(1);
  const [visible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    if (type === 'image' && media.length > 0) {
      Image.getSize(media[0].original_url, (w, h) => {
        setImageW(w);
        setImageH(h);
      });
    }
  }, [media, type]);

  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'flex-end',
        paddingVertical: 15,
      }}
    >
      <View style={{ position: 'relative' }}>
        <View
          style={{
            width: 0,
            height: 0,
            borderLeftWidth: 0,
            borderRightWidth: 40,
            borderTopWidth: 20,
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            borderTopColor: COLORS.RED_PRIMARY,
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
        ></View>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 8,
            color: COLORS.WHITE,
            bottom: 0,
            right: 30,
            position: 'absolute',
            zIndex: 4,
          }}
        >
          {time}
        </Text>
        <View
          style={{
            backgroundColor: COLORS.RED_PRIMARY,
            padding: 10,
            borderRadius: 16,
            marginRight: 20,
            minWidth: 50,
          }}
        >
          {type === 'image' && media.length > 0 ? (
            <TouchableOpacity
              onPress={() => {
                setIsVisible(true);
              }}
            >
              <Image
                source={{ uri: media[0].original_url }}
                style={{
                  width: IS_WEB
                    ? Math.min(SCREEN_WITDH / 6, media[0].image_sizes.width)
                    : Math.min(SCREEN_WITDH / 2, media[0].image_sizes.width),
                  height: IS_WEB
                    ? Number(
                        Math.min(SCREEN_WITDH / 6, media[0].image_sizes.width) *
                          (media[0].image_sizes.height /
                            media[0].image_sizes.width)
                      ) ?? 0
                    : Number(
                        Math.min(SCREEN_WITDH / 2, media[0].image_sizes.width) *
                          (media[0].image_sizes.height /
                            media[0].image_sizes.width)
                      ) ?? 0,
                  marginBottom: 5,
                }}
              />
            </TouchableOpacity>
          ) : (
            <View style={{ maxWidth: 300 }}>
              <RenderHTML
                source={{ html: content ?? '' }}
                tagsStyles={{
                  body: {
                    marginTop: 0,
                    color: COLORS.WHITE,
                    fontWeight: '500',
                    marginBottom: 0,
                    fontFamily: FONTS.AvenirMedium,
                    fontSize: 16,
                  },
                }}
              />
            </View>
          )}
        </View>
      </View>
      {/* Disable on website */}
      {/* {type === 'image' && media.length > 0 && (
        <EnhancedImageViewing
          images={[{ uri: media[0].original_url }]}
          imageIndex={0}
          visible={visible}
          onRequestClose={() => setIsVisible(false)}
          swipeToCloseEnabled={true}
        />
      )} */}
    </View>
  );
};

export default SendMessage;
